import { getAccOrigin } from '@adsk/acs-sc-web-platform-api';

import { VERSION_1, VERSION_2 } from '../consts';

export const getDeepLink = (
  entity: { id: string },
  projectId: string,
  type = '',
  isCustomReviewEnabled = false,
) => {
  const version = isCustomReviewEnabled ? VERSION_2 : VERSION_1;
  const url = `${getAccOrigin()}/build/submittals/${version}/projects/${projectId}/${type.toLowerCase()}/${
    entity.id
  }`;

  return url;
};
